import React, { useState, useEffect, useRef } from 'react';
import AuthService from '../../services/api/auth';
import AdyenCheckout from '@adyen/adyen-web';
import '@adyen/adyen-web/dist/adyen.css';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {
    creditCardBrandsSelector,
    paymentMethodCreditCardSelector,
    paymentMethodsSelector,
} from '../../redux/payment/selector';
import { setPaymentMethods } from '../../redux/payment/actions';
import { languageSelector } from '../../redux/application/selector';
import ErrorList from '../../components/ErrorList';

const PaymentButton = ({ isValid, onSubmit }) => (
    <button type="submit" className="btn btn-primary btn-block" disabled={!isValid} onClick={e => onSubmit(e)}>
        {window.VULOG_TRANSLATE('Add card')}
    </button>
);

const PaymentCCAdyenScreen = ({ onSetPaymentMethods, paymentMethods, history, locale }) => {
    const cardRef = useRef(null);
    const [result, setResult] = useState('');
    const [action, setAction] = useState('');
    const [isValid, setIsValid] = useState('');
    const [data, setData] = useState('');
    const [isFetching, setIsFetching] = useState(false);
    const [paymentComponent, setPaymentComponent] = useState(null);
    const [errors, setErrors] = useState([]);

    const processPaymentResponse = paymentRes => {
        if (paymentRes.action) {
            paymentComponent.handleAction(paymentRes.action);
            setAction(paymentRes.action);
        } else {
            setResult(paymentRes.resultCode);
            switch (paymentRes.resultCode) {
                case 'Authorised':
                    history.push(`/register/payment-result?status=Authorised&next=${paymentRes.next}`);
                    break;
                case 'Pending':
                case 'Received':
                    history.push(`/register/payment-result?status=Pending&next=${paymentRes.next}`);
                    break;
                case 'Refused':
                    history.push(`/register/payment-result?status=Refused&next=${history.location.pathname}`);
                    break;
                default:
                    history.push(`/register/payment-result?status=error&next=${history.location.pathname}`);
                    break;
            }
        }
    };

    const onChange = (state, component) => {
        setIsValid(state.isValid);
        setData(state.data);
        setPaymentComponent(component);
    };

    const onSubmit = event => {
        event.preventDefault();
        setIsFetching(true);
        setErrors([]);
        if (isValid) {
            AuthService.makeAPayment({
                ...data,
                origin: window.location.origin,
            })
                .then(response => {
                    processPaymentResponse(response);
                    setIsFetching(false);
                })
                .catch(error => {
                    setIsFetching(false);
                    if (error.data && error.data.message) {
                        const newErrors = [...errors, error.data.message];
                        setErrors(newErrors);
                    }
                });
        }
    };

    const onAdditionalDetails = state => {
        AuthService.getPaymentResultDetails({ data: state.data }).then(response => {
            setResult(response.resultCode);
            processPaymentResponse(response);
        });
    };

    const config = {
        locale: locale || 'en_US', // The shopper's locale. For a list of supported locales, see https://docs.adyen.com/online-payments/components-web/localization-components.
        environment: window.VULOG_CONFIG && window.VULOG_CONFIG.ADYEN_TEST ? 'test' : 'live', // When you're ready to accept live payments, change the value to one of our live environments https://docs.adyen.com/online-payments/components-web#testing-your-integration.
        clientKey: window.VULOG_CONFIG && window.VULOG_CONFIG.ADYEN_CLIENT_KEY, // Your client key. To find out how to generate one, see https://docs.adyen.com/development-resources/client-side-authentication. Web Components versions before 3.10.1 use originKey instead of clientKey.
        onChange: onChange,
        onAdditionalDetails: onAdditionalDetails,
        showPayButton: false,
    };

    useEffect(() => {
        AuthService.getPaymentMethod().then(response => {
            onSetPaymentMethods(response.paymentMethods);
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        const checkout = new AdyenCheckout({
            ...config,
            paymentMethodsResponse: paymentMethods,
        });
        checkout
            .create('card', {
                hasHolderName: true,
                holderNameRequired: true,
            })
            .mount(cardRef.current);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [paymentMethods]);

    return (
        <div className="container-fluid wrapper">
            {window.VULOG_CONFIG.ERROR_DISPLAY_TOP && <ErrorList errors={errors} />}
            <div className="page__title">{window.VULOG_TRANSLATE('Add your card')}</div>
            <form>
                <div className={'overlay__wrapper mt-2'}>
                    <div className={'overlay__wrapper__content'}>
                        <div className={'overlay__wrapper__content__center'}>
                            <div id="component-container" ref={cardRef}></div>
                        </div>
                    </div>
                </div>

                <footer className={'overlay__wrapper__footer mt-5'}>
                    {!result && !action && <PaymentButton isValid={isValid && !isFetching} onSubmit={onSubmit} />}
                </footer>
            </form>
            {!window.VULOG_CONFIG.ERROR_DISPLAY_TOP && <ErrorList errors={errors} />}
        </div>
    );
};

const mapStateToProps = state => ({
    paymentMethods: paymentMethodsSelector(state),
    paymentMethodCreditCard: paymentMethodCreditCardSelector(state),
    creditCardBrands: creditCardBrandsSelector(state),
    locale: languageSelector(state),
});

const mapActionsToProps = dispatch => ({
    onSetPaymentMethods: bindActionCreators(setPaymentMethods, dispatch),
});

export default connect(mapStateToProps, mapActionsToProps)(PaymentCCAdyenScreen);
